import "@modules/util/LiveCharacterCounter"
import "@modules/util/failed-image-detector"

import "@modules/bookmarks/tags/tag-list"
import { renderEntryRatings } from "@modules/bookmarks/entries/entry-ratings"

import "@modules/bookmarks/bookmarks-mobile.css"
import { updateMerkzettelStateInMenu } from "@modules/bookmarks/bookmarks-menu-item.ts"
import { initializeCards } from "@modules/bookmarks/entries/entry-cards"
import { lookForBookmarksThatCanBeMerged, memoryModalNotShowAgain } from "@modules/bookmarks/entries/merge-cookie.ts"
import { addEventListenersForSideBarOptions } from "@modules/bookmarks/entries/sideBarOptions.ts"
import { hideAdProviderWhenTagIsSelected } from "@modules/bookmarks/tags/Tag.ts"
import { addListenersToMailButton } from "@modules/favourite-bookmarks/favourite-bookmarks.ts"

initializeCards()
addListenersToMailButton()
renderEntryRatings()
lookForBookmarksThatCanBeMerged()
memoryModalNotShowAgain()
updateMerkzettelStateInMenu(true)
addEventListenersForSideBarOptions()
hideAdProviderWhenTagIsSelected()
